// extracted by mini-css-extract-plugin
export default {"main":"Sidebar_main__XIInN","side":"Sidebar_side__KmGNc","brand":"Sidebar_brand__czepv","fill":"Sidebar_fill__MeB8a"};